import { render, staticRenderFns } from "./pkg4.vue?vue&type=template&id=30a2fd8f&"
import script from "./pkg4.vue?vue&type=script&lang=js&"
export * from "./pkg4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports